import {
  DAY_OF_WEEK,
  FILTER_PERIOD_OPTIONS,
  FILTER_TIME_OPTIONS,
  WEEK_TYPE,
} from '@/utils/filter/filterOptions.js';

/**
 * @description
 * 선택된 나이 리스트를 텍스트로 만드는 유틸 함수
 */
const _ageFilterText = ageSelectedList => {
  if (!ageSelectedList || !ageSelectedList.length) return '';

  const ageStringArray = [];
  let temp = null;
  let count = 0;

  // 선택된 age값 배열을 순회하면서 동시에 3개 이상 이어진 숫자가 있다면 ex) 7,8,9 -> 7-9 로 합쳐줍니다
  for (let i = 0; i < ageSelectedList.length; i++) {
    if (temp === null) temp = ageSelectedList[i];

    if (ageSelectedList[i] + 1 === ageSelectedList[i + 1]) {
      count++;
    } else {
      if (count > 1) {
        ageStringArray.push(`${temp}-${ageSelectedList[i]}`);
      } else {
        ageStringArray.push(temp);
        if (count !== 0) ageStringArray.push(ageSelectedList[i]);
      }
      count = 0;
      temp = null;
    }
  }

  // 위에서 아무 값도 안들어갔다면 (전부 다 이어져있다면) 의 예외처리
  if (ageStringArray.length === 0) {
    ageStringArray.push(
      `${ageSelectedList[0]}-${ageSelectedList[ageSelectedList.length - 1]}`,
    );
  }

  // 다 이어붙인 후
  let ageString = ageStringArray.join(', ');

  // 마지막 값이 12면 +살 아니면 살 을 붙여 텍스트를 완성합니다
  ageString += ageString.slice(-2) === '13' ? '+살' : '살';

  return ageString;
};

const _dateToString = (startIsoString, endIsoString) => {
  if (startIsoString === endIsoString) {
    const [, month, date] = startIsoString.split('-');
    return `${+month}월 ${+date}일`;
  } else {
    const [year1, month1, date1] = startIsoString.split('-');
    const [year2, month2, date2] = endIsoString.split('-');

    if (year1 !== year2)
      return `${+year1.slice(-2)}년 ${+month1}월 ${+date1}일 ~ ${+year2.slice(
        -2,
      )}년 ${+month2}월 ${+date2}일`;

    if (month1 === month2) return `${+month1}월 ${+date1}일 ~ ${+date2}일`;

    return `${+month1}월 ${+date1}일 ~ ${+month2}월 ${+date2}일`;
  }
};

const _scheduleTextMaker = ({
  period,
  dayOfWeek,
  weekType,
  startTimeIdx = 0,
  endTimeIdx = FILTER_TIME_OPTIONS.length - 1,
  classStartDate,
  classEndDate,
}) => {
  const resultArray = [];

  const currentPeriod = FILTER_PERIOD_OPTIONS.find(f => f.value === period);
  if (currentPeriod) resultArray.push(currentPeriod.text);

  if (classStartDate) {
    resultArray.push(_dateToString(classStartDate, classEndDate));
  }

  const currentWeekType = WEEK_TYPE.find(w => w.value === weekType);
  const dayOfWeekArray = (dayOfWeek && dayOfWeek.split(',')) || [];

  if (currentWeekType) {
    resultArray.push(currentWeekType.text);
  } else if (dayOfWeekArray && dayOfWeekArray.length > 0) {
    resultArray.push(
      dayOfWeekArray.reduce((acc, cur, i) => {
        const idxValue = parseInt(cur) || 0;
        const dayText = DAY_OF_WEEK.find(d => d.value === idxValue)?.text;
        if (!dayText) return acc;
        if (i === 0) return dayText;
        return acc + '/' + dayText;
      }, ''),
    );
  }

  if (startTimeIdx > 0 || endTimeIdx < FILTER_TIME_OPTIONS.length - 1) {
    const startTime = FILTER_TIME_OPTIONS[startTimeIdx].text;
    const endTime = FILTER_TIME_OPTIONS[endTimeIdx].text;

    if (startTime.slice(0, 2) === endTime.slice(0, 2)) {
      resultArray.push(`${startTime} ~ ${endTime.slice(3)}`);
    } else {
      resultArray.push(`${startTime} ~ ${endTime}`);
    }
  }

  return resultArray.join(' · ');
};

/**
 * @description
 * query로 필터값을 text화해 seo를 위한 summary를 만들어줍니다.
 */
const getFilterText = query => {
  const {
    keyword,
    startTimeIdx,
    endTimeIdx,
    selectedDayOfWeek: dayOfWeek,
    selectedWeekType: weekType,
    selectedPeriodOption: period,
    selectedAge,
    classStartDate,
    classEndDate,
  } = query;

  const resultArray = [];
  if (keyword && keyword.length) resultArray.push(keyword);
  else resultArray.push('모든 수업');

  const scheduleText = _scheduleTextMaker({
    period,
    dayOfWeek,
    weekType,
    startTimeIdx,
    endTimeIdx,
    classStartDate,
    classEndDate,
  });

  if (scheduleText && scheduleText.length) resultArray.push(scheduleText);
  if (selectedAge && Array.isArray(selectedAge) && selectedAge.length > 0)
    resultArray.push(_ageFilterText(selectedAge));

  return resultArray.join(' / ');
};

export default getFilterText;
